import { render, staticRenderFns } from "./OpenCreation.vue?vue&type=template&id=611e488a&scoped=true&"
import script from "./OpenCreation.vue?vue&type=script&lang=js&"
export * from "./OpenCreation.vue?vue&type=script&lang=js&"
import style0 from "./OpenCreation.vue?vue&type=style&index=0&id=611e488a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611e488a",
  null
  
)

export default component.exports